module.exports = __webpack_public_path__ + "08a4134d46ae3f20fe197735c6312c56.png";